import { render, staticRenderFns } from "./idProofsView.vue?vue&type=template&id=74c8ad46&"
import script from "./idProofsView.vue?vue&type=script&lang=js&"
export * from "./idProofsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports